<template>
<div class="wrap range-custom-wrapper" role="group" :aria-labelledby='`${rangeId}-multi-lbl`' :style="{ '--minval': minimumValue, '--maxval': maximumValue, '--min': rangeMin, '--max': rangeMax }">
  <div :id="`${rangeId}-multi-lbl`" class="heading-h5">{{ rangeLabel }}</div>
  
  <label class='sr-only' :for="`${rangeId}-min`">Value A:</label>
  <input :id="`${rangeId}-min`"
    type="range"
    :min="rangeMin"
    :max="rangeMax"
    v-model="minimumValue"
    @change="handleRangeChange"
    :step="rangeStep"
  />
  <div ref="minimumTag" class="range-value-tag" :id="`${rangeId}-min-value-tag`" :style="tagStyle(`${rangeId}-min-value-tag`)">{{tagDisplayModifier(minimumValue)}}</div>
  
  <label class='sr-only' :for="`${rangeId}-max`">Value B:</label>
  <input :id="`${rangeId}-max`"
    type="range"
    :min="rangeMin"
    :max="rangeMax"
    v-model="maximumValue"
    @change="handleRangeChange"
    :step="rangeStep"
  />
  <div ref="maximumTag" class="range-value-tag" :id="`${rangeId}-max-value-tag`" :style="tagStyle(`${rangeId}-max-value-tag`)">{{tagDisplayModifier(maximumValue)}}</div>
</div>
</template>

<script setup>
import { ref, watch } from 'vue';

const props = defineProps({
  rangeId: {
    type: String,
    required: true,
  },
  rangeLabel: {
    type: String,
    required: true,
  },
  rangeMin: {
    type: [String,Number],
    default: 0,
  },
  rangeMax: {
    type: [String,Number],
    default: 10,
  },
  rangeStep: {
    type: [String,Number],
    default: 1,
  },
  tagModifier: {
    type: [String, Array],
    default: '',
  },
  minValue: {
    type: [String,Number],
    default: 0,
  },
  maxValue: {
    type: [String, Number],
    default: 1,
  },

});

const emit = defineEmits(['range-change']);

const minimumTag = ref(null);
const maximumTag = ref(null);

const minimumValue = ref(props.minValue ?? props.rangeMin);
const maximumValue = ref(props.maxValue ?? props.rangeMax);

const tagStyle = (id) => {
  const isMin = id.includes("min");
  const tagWidth = (isMin ? minimumTag.value : maximumTag.value)?.clientWidth;
  const progress = (isMin ? minimumValue.value : maximumValue.value) / props.rangeMax;
  const base = `calc(${(progress * 100)}% - ${tagWidth / 2 || 20}px`;
  return {
    'left': progress > 0.5 ? `${base} - ${(progress * 10) - (10 - (progress * 10))}px)` : `${base} + ${(10 - (progress * 20))}px)`,
  }
};

const tagDisplayModifier = (value) => {
  const displayValue = value >= 1000 ? (value / 1000).toFixed(1) + 'k' : value
  if(props.tagModifier) {
    if(typeof props.tagModifier === 'string') {
      return `${displayValue} ${props.tagModifier}`;
    } else {
      // it is an array
      return props.tagModifier[value];
    }
  }

  return displayValue;
};


function handleRangeChange(e) {
  if(minimumValue.value == maximumValue.value) {
    if(e.target.id.includes('max')) {
      maximumValue.value = parseInt(maximumValue.value) + parseInt(props.rangeStep);
    } else {
      minimumValue.value = parseInt(minimumValue.value) - parseInt(props.rangeStep);
    }
  }
  if(parseInt(minimumValue.value) > parseInt(maximumValue.value)) {
    const vals = [minimumValue.value, maximumValue.value];
    minimumValue.value = vals[1];
    maximumValue.value = vals[0];
  }

  emit('range-change', {minValue: parseInt(minimumValue.value), maxValue: parseInt(maximumValue.value)});
}

</script>